export const DEFAULT_TIMEOUT = 3000
export const DISPLAY_ITEMS_NUM = 0 // 0 means infinite
